import React from 'react';
import { Icon } from '../../components/Icon';
// import { Pagination } from '../../components/ui/Pagination';
// import type { Equipo } from '../../types/equipo';
// import type { Device } from '../../types/device';
import type { Process } from '../../types/lead';
// import { formatCurrency, formatDate } from '../../utils/formatters';

interface EquiposTableProps {
  equipos: Process[];
  loading: boolean;
  currentPage: number;
  totalPages?: number;
  pageSize: number;
  total?: number;
  onPageChange: (page: number) => void;
  onRefresh?: () => void;
}

export const EquiposTable: React.FC<EquiposTableProps> = ({
  equipos,
  loading,
  // currentPage,
  // totalPages,
  // pageSize,
  // total,
  // onPageChange,
  // onRefresh
}) => {
  // const handleView = (equipo: Device) => {
  //   alert(`Ver detalles de: ${equipo.name_device}`);
  //   // Implementar navegación a vista de detalles
  // };

  // const handleEdit = (equipo: Device) => {
  //   alert(`Editar equipo: ${equipo.name_device}`);
  //   // Implementar navegación a formulario de edición
  // };

  // const handleDelete = async (equipo: Device) => {
  //   if (window.confirm(`¿Estás seguro de eliminar a ${equipo.name_device}?`)) {
  //     try {
  //       // Aquí iría la llamada a la API para eliminar
  //       // await equiposApi.deleteEquipo(equipo.id);
  //       alert(`Equipo ${equipo.name_device} eliminado`);
  //       // onRefresh();
  //     } catch (error) {
        
  //       alert(`Error al eliminar el equipo: ${error}`);
  //     }
  //   }
  // };

  return (
    <div className="card">
      <div className="p-6 border-b border-gray-200 dark:border-gray-700">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
            Lista de Procesos
          </h3>
          {/* <button
            onClick={onRefresh}
            disabled={loading}
            className="flex items-center px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors disabled:opacity-50"
          >
            <Icon name={loading ? "loading" : "refresh"} className={`w-4 h-4 mr-2 ${loading ? 'animate-spin' : ''}`} />
            Actualizar
          </button> */}
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 dark:bg-gray-700">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Nombre
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Descripcion
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Color
              </th>
              
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Orden
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
            {loading ? (
              <tr>
                <td colSpan={7} className="px-6 py-12 text-center">
                  <div className="flex flex-col items-center justify-center space-y-2">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                    <span className="text-gray-600 dark:text-gray-300">Cargando procesos...</span>
                  </div>
                </td>
              </tr>
            ) : equipos.length === 0 ? (
              <tr>
                <td colSpan={7} className="px-6 py-12 text-center">
                  <div className="flex flex-col items-center justify-center space-y-2">
                    <Icon name="users" className="w-12 h-12 text-gray-400" />
                    <span className="text-gray-500 dark:text-gray-400 text-lg">
                      No se encontraron procesos
                    </span>
                    <span className="text-gray-400 dark:text-gray-500 text-sm">
                      Intenta ajustar los filtros de búsqueda
                    </span>
                  </div>
                </td>
              </tr>
            ) : (
              equipos.map((equipo) => (
                <tr 
                  key={equipo.id} 
                  className="hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150"
                >
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      
                      <div className="ml-4">
                        <div className="text-sm font-medium text-gray-900 dark:text-white">
                          {equipo.stage}
                        </div>
                        <div className="text-xs text-gray-500 dark:text-gray-400">
                          {equipo.created_at}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900 dark:text-white">
                      {equipo.stage}
                    </div>
                  </td>
                 
                  <td className="px-6 py-4 whitespace-nowrap">
                    
                      {equipo.color }
                    
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <div className="flex items-center justify-center space-x-2">
                      
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Paginación */}
      {/* {totalPages > 1 && (
        <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            pageSize={pageSize}
            total={total}
            onPageChange={onPageChange}
          />
        </div>
      )} */}
    </div>
  );
};